const profile = {
	SUPERADMIN: 1,
  PERSONAL: 2,
  CLIENTE: 3,
  PROVEEDOR: 4,
}

export default profile;
